var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-card',{attrs:{"square":""}},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('vue-highcharts',{attrs:{"options":_vm.highchartOption}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }